export const COUNTRY_CODES = {
  CO001: 'countryNotExist',
};
